import { HttpClient } from '@opallabs/api'

const postPresentationPdfExport = (params) =>
  HttpClient().post('/presentations/exports', params)
const postMomentPdfExport = (params) =>
  HttpClient().post(`/moments/${params.id}/exports`, params)

const createPdfExport = (params) => () => {
  const {
    exportSize: export_size,
    id,
    showLabels: show_labels,
    showNotes: show_notes,
    showOptions: show_options,
    type = 'moment',
  } = params

  const exportEndpoint =
    type === 'moment' ? postMomentPdfExport : postPresentationPdfExport

  exportEndpoint({
    type,
    export_size,
    id,
    show_labels,
    show_notes,
    show_options,
  })
}

export default createPdfExport
